import z from "zod";

export const BankTypeSchema = z.enum([
  "KB_KOOKMIN",
  "SHINHAN",
  "WOORI",
  "HANA",
  "NH_NONGHYUP",
  "IBK",
  "KDB",
  "SC",
  "CITI",
  "KYONGNAM",
  "GWANGJU",
  "DAEGU",
  "BUSAN",
  "JEONBUK",
  "JEJU",
  "SH_SUHYUP",
  "KAKAO",
  "K_BANK",
  "TOSS",
  "SAEMAUL",
  "SHINHYUP",
  "POST_OFFICE",
]);

export type BankType = z.infer<typeof BankTypeSchema>;

export const CreateBankTransferCommandSchema = z.object({
  bank: BankTypeSchema,
  accountNumber: z.string(),
  accountHolder: z.string(),
  isEnabled: z.boolean(),
});

export type CreateBankTransferCommand = z.infer<
  typeof CreateBankTransferCommandSchema
>;

export const UpdateBankTransferCommandSchema = z.object({
  bank: BankTypeSchema,
  accountNumber: z.string(),
  accountHolder: z.string(),
  isEnabled: z.boolean(),
});

export type UpdateBankTransferCommand = z.infer<
  typeof UpdateBankTransferCommandSchema
>;

export const BankTransferEntitySchema = z.object({
  id: z.number(),
  shopId: z.number(),
  bank: BankTypeSchema,
  accountNumber: z.string(),
  accountHolder: z.string(),
  isEnabled: z.boolean(),
});

export type BankTransferEntity = z.infer<typeof BankTransferEntitySchema>;
